const Header = {
  init() {
    Header.events();
    Header.toggle();
    Header.subMenu();
    Header.toggleLanguages();
    Header.headerMessage();
    Header.searchToggle();
    Header.mobileMenu();
  },

  events() {
    Header.scroll();
    $(window).scroll(function () {
      Header.scroll();
    });
  },

  toggle() {
    var windowScrollTop = $(window).scrollTop();
    // toggle main navigation mobile
    $(".toggle-menu").on("click", function (e) {
      e.preventDefault();

      $(this).toggleClass("active");

      $(".header").toggleClass(
        "header--was-scrolled",
        $(".header").hasClass("header--scrolled")
      );
      if (!$(".header").hasClass("header--mobile-open"))
        windowScrollTop = $(window).scrollTop();
      $(".header").toggleClass("header--mobile-open");
      $("html").toggleClass("no-scroll");
      $("html, body").scrollTop(windowScrollTop);
    });

    // Toggle dropdown
    $(".languages__toggle").on("click", function (e) {
      e.preventDefault();
      var btn = $(this);
      btn.toggleClass("languages__toggle-open");
      btn.next().slideToggle(250);
    });
  },

  subMenu() {
    // Submenu functionality
    if ($(window).width() < 1200) {
      // 3rd level submenu on mobile
      $(
        ".mobile-menu .menu > .menu-item > .sub-menu > .menu-item-has-children > .sub-menu > .menu-item-has-children > .menu-item__wrap .menu-item__toggle-submenu"
      ).on("click", function (e) {
        e.preventDefault();
        var btn = $(this);
        var menuItem = btn.closest(".menu-item");
        var siblings = menuItem.siblings();

        // Handle the more specific case
        menuItem.toggleClass("menu-item--submenu-open");
        siblings.toggleClass("hidden");

        // Stop the event from propagating to the general handler
        e.stopImmediatePropagation();
      });

      // General click event handler
      $(".menu-item__toggle-submenu").on("click", function (e) {
        e.preventDefault();

        // This code will not run if the more specific handler was triggered
        var btn = $(this);
        var menuItem = btn.closest(".menu-item");
        var siblings = menuItem.siblings();

        // Handle the general case
        menuItem.toggleClass("menu-item--submenu-open");
        menuItem.find(".sub-menu").first().slideToggle(250);

        siblings.children(".sub-menu").slideUp(250);
        siblings.removeClass("menu-item--submenu-open");

        if ($(".menu-item--submenu-open").length) {
          $("html").addClass("no-scroll");
        } else {
          $("html").removeClass("no-scroll");
        }
      });
    } else {
      $(
        ".main-nav__list > .menu-item > .sub-menu > .menu-item > .sub-menu > .menu-item-has-children > .menu-item__wrap"
      ).on("click", function (e) {
        e.preventDefault();

        $(".main-nav__list .sub-menu").removeClass("open");

        $(this).next().addClass("open");
      });
    }

    // Add head element to submenu.
    $(".header-menu .menu-item.menu-item-has-children").on(
      "click",
      function (e) {
        const menuItem = $(e.currentTarget);
        const menuLabel = menuItem.find("> .sub-menu > .menu-item__parent");

        const parentEl = menuItem.children(".menu-item__wrap").html();

        menuLabel.html(
          `${parentEl} <button class="btn menu-item__close"></button>`
        );

        $(".header-menu .menu-item__close").on("click", function (e) {
          setTimeout(() => {
            menuItem.find(".sub-menu").removeClass("open");
          }, 50);
        });
      }
    );
  },

  scroll() {
    var st = $(window).scrollTop();
    if (st > 110) {
      $(".header").addClass("header--scrolled");
    } else {
      $(".header").removeClass("header--scrolled");
    }
  },

  mobileMenu() {
    // Main item toggle → open sub-panel
    $('.mobile-nav__toggle').on('click', function () {
      const $btn   = $(this);
      const $item  = $btn.closest('.mobile-nav__item');
      const $panel = $item.find('> .mobile-nav__sub-panel');
      const isOpen = $item.hasClass('open');

      // Close all other open items
      $('.mobile-nav__item.open').not($item).each(function () {
        $(this).removeClass('open')
          .find('> .mobile-nav__sub-panel').slideUp(300);
        $(this).find('.mobile-nav__toggle').attr('aria-expanded', 'false');
      });

      $item.toggleClass('open', !isOpen);
      $btn.attr('aria-expanded', !isOpen);
      $panel.stop(true, true).slideToggle(300);
    });

    // Submenu item toggle → open third-level list
    $('.mobile-nav__sub-toggle').on('click', function () {
      const $btn      = $(this);
      const $subitem  = $btn.closest('.mobile-nav__subitem');
      const $children = $subitem.find('> .mobile-nav__children');
      const isOpen    = $subitem.hasClass('open');

      $subitem.toggleClass('open', !isOpen);
      $btn.attr('aria-expanded', !isOpen);
      $children.stop(true, true).slideToggle(250);
    });
  },

  searchToggle() {
    const $searchBox = $('.search-box');

    $('#search-toggler').on('click', function () {
      $searchBox.addClass('active');
    });

    $('.button-close-search').on('click', function () {
      $searchBox.removeClass('active');
    });

    $(document).on('keydown', function (e) {
      if (e.key === 'Escape') {
        $searchBox.removeClass('active');
      }
    });
  },

  headerMessage() {
    const $msg = $('.header__message');
    if (!$msg.length) return;

    $('#close-header-message').on('click', function () {
      const version = $msg.data('version');
      const expires = new Date();
      expires.setFullYear(expires.getFullYear() + 1);
      document.cookie = `hmsg_dismissed=${version}; path=/; expires=${expires.toUTCString()}`;
      $msg.slideUp(300, function () { $(this).remove(); });
    });
  },

  toggleLanguages() {
    $(".languages__open-btn").on("click", function (e) {
      e.preventDefault();
      $(".languages__dropdown").toggleClass("hidden");
      $(this).toggleClass("active");
    });

    // Close the dropdown when clicking inside the dropdown itself
    $(".languages__dropdown").on("click", function () {
      $(".languages__dropdown").addClass("hidden");
      $(".languages__open-btn").removeClass("active");
    });

    // Close the dropdown if the user clicks outside of it
    $(document).on("click", function (e) {
      if (
        !$(e.target).closest(".languages__open-btn, .languages__dropdown")
          .length
      ) {
        $(".languages__dropdown").addClass("hidden");
        $(".languages__open-btn").removeClass("active");
      }
    });
  },
};
export default Header;
